export const SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
export const LAYOUT = {
  basic: 'basic',
  column: 'column',
  grid: 'grid'
};
export const PATTERN = {
  required: {
    pattern: /[^\s]{1,}/,
    message: 'Field is required'
  },
  alphaOnly: {
    pattern: /^[A-Za-z]*$/,
    message: 'Cannot contain non-alpha characters.'
  },
  numericOnly: {
    pattern: /^[0-9]*$/,
    message: 'Cannot contain non-numeric characters.'
  },
  alphaNumericOnly: {
    pattern: /^[A-Za-z0-9]*$/,
    message: 'Cannot contain non-numeric characters.'
  },
  name: {
    pattern: /^[A-Za-z ,-/'/.]*$/,
    message: 'Invalid Characters'
  },
  addressCharacters: {
    pattern: /^[A-Za-z0-9. -/']*$/,
    message: 'Invalid Characters.'
  },
  zipCharacters: {
    pattern: /^[0-9. -/']*$/,
    message: 'Invalid Characters.'
  },
  email: {
    pattern: /^(([^<>()[\]\\.,;:\s@"!'#$%^&*]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9-]+\.)+[a-zA-Z-]{2,}))$/,
    message: 'Invalid email.'
  }
};